<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>
            &nbsp;&nbsp;&nbsp; Manage Global Configuration
            <span style="padding-left:50px;" class="alert-icon">⚠️</span>
            <span style="text-align:center; font-size: 15px !important; color: #fffa5f; "> User must restart app server for global config changes to take effect. </span>
        </h2>
    </div>
</div>
<div class="">
    <span style="float: right; padding-top: 7px; padding-right: 5px;">
        <button pButton icon="pi pi-file-import" label="Import from config file" (click)="fetchGlobalSettingsFromXmlFile()"></button> &nbsp;
        <button pButton icon="pi pi-undo" label="Clear Settings" (click)="resetSettings();" [disabled]="isDisabled"></button>
    </span>
</div>
<div class="p-fluid" id="globalmainId" style="background-color:white !important">
    <form class="card pb-0 pt-0 col-12"
          [formGroup]="frmApplicationSettings"
          (ngSubmit)="onSubmit()">
        <div id="ApplicationSettings" class="p-fluid" style="padding-top: 7px;">
            <h5 class="col-5 md:col-1 blueBar mt-1 mb-2 ml-2 mr-3 r-2">
                General Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid">
                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Enterprise Id
                            <i class="pi pi-exclamation-circle pt-1"
                               (mouseover)="getContolTip('ENTERPRISEID')"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"></i>
                        </label>
                        <input id="enterpriseId"
                               pInputText
                               type="text"
                               formControlName="enterpriseId" />
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Maximum Page Size<i class="pi pi-exclamation-circle pt-1  custom-tooltip"
                                                pTooltip="{{ speakText }}"
                                                tooltipPosition="right"
                                                (mouseover)="getContolTip('PAGESIZE')"></i>
                        </label>
                        <input id="apiDataPageSize"
                               type="number"
                               pInputText
                               formControlName="apiDataPageSize" />
                    </span>
                </div>

                <div class="field col-6 md:col-3 mb-0 pt-0">
                    <label class="pl-3 Font">
                        Log Level
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('LOGDETAILS')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="logLevel"
                                    [options]="logLevelOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Chromium Base Directory
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('CHROMIUM')"></i>
                        </label>
                        <input pInputText
                               id="chromiumBaseDirectory"
                               type="text"
                               formControlName="chromiumBaseDirectory" />
                    </span>
                </div>


                <div class="col-6 md:col-3 Pad">
                    <span>
                        <input id="isEmergencyTokenEnabled"
                               type="checkbox"
                               formControlName="isEmergencyTokenEnabled"
                               binary="true" />
                        <label class="pl-2 Font">
                            Enable Emergency Token
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('EMERGENCYTOKENENABLED')"></i>
                        </label>
                    </span>
                </div>
                <div class="col-6 md:col-3 Pad">
                    <span>
                        <input id="isEmailMandatory"
                               type="checkbox"
                               formControlName="isEmailMandatory"
                               binary="true" />
                        <label class="pl-2 Font">
                            Email Mandatory
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('EMAILMANDATORY')"></i>
                        </label>
                    </span>
                </div>


                <div class="col-6 md:col-3 Pad">
                    <span>
                        <input id="isCellMandatory"
                               type="checkbox"
                               formControlName="isCellMandatory"
                               binary="true" />
                        <label class="pl-2 Font">
                            Cell Phone Mandatory
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('CELLPHONEMANDATORY')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3 Pad" formGroupName="applicationFeatures">
                    <span>
                        <input id="showReports" type="checkbox" formControlName="showReports" binary="true" />
                        <label class="pl-2 Font">
                            Show Reports
                            <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('SHOWREPORTS')"></i>
                        </label>
                    </span>
                </div>





                <div class="col-6 md:col-3 Pad">
                    <span>
                        <input id="isImportSettings"
                               type="checkbox"
                               formControlName="isImportSettings"
                               binary="true" />
                        <label class="pl-2 Font">
                            Import Settings
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="This setting makes import from config file option visible for the  Global Admin to import practice config settings from CareFinity 3.X Config.xml file."
                               tooltipPosition="right"></i>
                        </label>
                    </span>
                </div>





            </div>
        </div>
        <div id="accountPolicy" formGroupName="accountPolicy">
            <h5 class="col-5 md:col-1 blueBar mt-5 mb-2 ml-2 mr-3 r-2">
                Account Policy
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid">
                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Session Timeout (Minutes)
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SESSIONTIMEOUT')"></i>
                        </label>
                        <input id="sessionTimeoutMinutes"
                               pInputText
                               type="number"
                               formControlName="sessionTimeoutMinutes" />
                    </span>
                </div>

                <div class="col-12 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Session Expiry Warning (Seconds)
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SESSIONTIMEOUTSEC')"></i>
                        </label>
                        <input id="sessionExpiryWarningBeforeSeconds"
                               pInputText
                               type="number"
                               formControlName="sessionExpiryWarningBeforeSeconds" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Password Expiry Days
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PASSWORDEXPIRY')"></i>
                        </label>
                        <input id="passwordExpiryDays"
                               pInputText
                               type="number"
                               formControlName="passwordExpiryDays" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Maximum Failed Login Attempts
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('FAILEDLOGINATTEMPTS')"></i>
                        </label>
                        <input id="maxFailedLoginAttempts"
                               pInputText
                               type="number"
                               formControlName="maxFailedLoginAttempts" />
                    </span>
                </div>

                <div class="field col-6 md:col-3 mb-0 p-fluid T pt-3">
                    <label class="pl-3 Font">
                        Multiple Sessions
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('MULTIPLESESSIONS')"></i>
                    </span>
                    <span class="p-float-label pl-2 P">
                        <p-dropdown formControlName="multipleSessions"
                                    [options]="multipleSessionsOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>
                    </span>
                </div>
            </div>
            <div class="col-12 grid">
                <div class="col-6 md:col-3" style="padding-top: 15px">
                    <span>
                        <input id="forceComplexPasswords"
                               type="checkbox"
                               formControlName="forceComplexPasswords"
                               binary="true" />
                        <label class="pl-2 Font">
                            Force Complex Passwords
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('FORCECOMPLEXPASSWORDS')"></i>
                        </label>
                    </span>
                </div>
            </div>

            <div class="col-12 grid">
                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Minimum Password Length
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('MINIMUMPASSWORD')"></i>
                        </label>
                        <input id="minPasswordLength"
                               type="number"
                               pInputText
                               formControlName="minPasswordLength"
                               [disabled]="isDisabled_ForceComplexPasswords" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Minimum Upper Case Chars
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('MINIMUMUPPER')"></i>
                        </label>
                        <input id="minUpperCaseChars"
                               pInputText
                               type="number"
                               formControlName="minUpperCaseChars"
                               [disabled]="isDisabled_ForceComplexPasswords" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Minimum Lower Case Chars
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('MINIMUMLOWER')"></i>
                        </label>
                        <input id="minLowerCaseChars"
                               pInputText
                               type="number"
                               formControlName="minLowerCaseChars"
                               [disabled]="isDisabled_ForceComplexPasswords" />
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Minimum Special Chars
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SPECIALCHARS')"></i>
                        </label>
                        <input id="minSpecialChars"
                               pInputText
                               type="number"
                               formControlName="minSpecialChars"
                               [disabled]="isDisabled_ForceComplexPasswords" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Minimum Numbers
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('MINNUMBER')"></i>
                        </label>
                        <input id="minNumbers"
                               pInputText
                               type="number"
                               formControlName="minNumbers"
                               [disabled]="isDisabled_ForceComplexPasswords" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Password History Count
                            <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('HISTORYCOUNT')"></i>
                        </label>
                        <input id="PasswordHistoryCount" pInputText type="number" formControlName="cantUseSamePasswordFor" [disabled]="isDisabled_ForceComplexPasswords" />
                    </span>
                </div>


            </div>

            <div id="applicationFeatures">
                <h5 class="col-5 md:col-1 blueBar mt-5 mb-2 ml-2 mr-3 r-2">
                    Multi Factor Authentication
                </h5>
                <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
                <div class="col-12 grid">
                    <div class="field col-6 md:col-3 mb-0 p-fluid T pt-3">
                        <label class="pl-3 Font">
                            MFA Type
                        </label>
                        <span>
                            <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('MFATYPE')"></i>
                        </span>
                        <span class="p-float-label pl-2 P">
                            <p-dropdown formControlName="mfaType"
                                        [options]="mfaTypeOptions"
                                        optionLabel="value"
                                        optionValue="key"
                                        dataKey="value">
                            </p-dropdown>
                        </span>
                    </div>

                    <div class="col-6 md:col-3" *ngIf="isMfaType">
                        <span>
                            <label class="pl-2 Font">
                                Country Code
                                <i class="pi pi-exclamation-circle pt-1"
                                   pTooltip="{{ speakText }}"
                                   tooltipPosition="right"
                                   (mouseover)="getContolTip('COUNTRYCODE')"></i>
                            </label>
                            <input id="CountryCode"
                                   pInputText
                                   type="text"
                                   formControlName="countryCode" />
                        </span>
                    </div>

                    <div class="col-6 md:col-3" *ngIf="isMfaType">
                        <span>
                            <label class="pl-2 Font">
                                Max Failed Otp Count
                                <i class="pi pi-exclamation-circle pt-1"
                                   pTooltip="{{ speakText }}"
                                   tooltipPosition="right"
                                   (mouseover)="getContolTip('FAILEDOTP')"></i>
                            </label>
                            <input id="maxFailedOtpCount"
                                   pInputText
                                   type="number"
                                   formControlName="maxFailedOtpCount" />
                        </span>
                    </div>

                    <div class="col-6 md:col-3" *ngIf="isMfaType">
                        <span>
                            <label class="pl-2 Font">
                                OTP Generator Link
                                <i class="pi pi-exclamation-circle pt-1"
                                   pTooltip="{{ speakText }}"
                                   tooltipPosition="right"
                                   (mouseover)="getContolTip('OTPGENERATOR')"></i>
                            </label>
                            <input id="OTpGeneratorLink"
                                   type="text"
                                   pInputText
                                   formControlName="oTpGeneratorLink" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div id="smtpSettings">
            <h5 class="col-5 md:col-1 blueBar mt-5 mb-2 ml-2 mr-3 r-2">
                Email Notification
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid">
                <div class="col-6 md:col-3">
                    <span>
                        <input id="emailNotifications"
                               type="checkbox"
                               formControlName="emailNotifications"
                               binary="true" />
                        <label class="pl-2 Font">
                            Email Notifications
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('EMAILNOTIFICATIONS')"></i>
                        </label>
                    </span>
                </div>
            </div>

            <div class="col-12 grid">
                <div class="col-6 md:col-3" formGroupName="smtpSettings">
                    <span>
                        <label class="pl-2 Font">
                            Host
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('HOST')"></i>
                        </label>
                        <input id="host"
                               pInputText
                               type="text"
                               formControlName="host"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>
                <div class="col-6 md:col-3" formGroupName="smtpSettings">
                    <span>
                        <label class="pl-2 Font">
                            Port
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PORT')"></i>
                        </label>
                        <input id="port"
                               pInputText
                               type="number"
                               formControlName="port"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>

                <div class="col-6 md:col-6" formGroupName="smtpSettings">
                    <span>
                        <label class="pl-2 Font">
                            From Address
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('FROMADD')"></i>
                        </label>
                        <input id="fromAddress"
                               pInputText
                               type="text"
                               formControlName="fromAddress"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>

                <div class="field col-6 md:col-3 mb-0 p-fluid T pt-1" formGroupName="smtpSettings">
                    <label class="pl-3 Font">
                        SMTP Security Options
                    </label>
                    <span>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('SMTP')"></i>
                    </span>
                    <span class="p-float-label pl-0 ">
                        <p-dropdown formControlName="security" [options]="smtpSecurityOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    dataKey="value">
                        </p-dropdown>

                    </span>
                </div>

                <div class="col-6 md:col-3" formGroupName="smtpSettings">
                    <span>
                        <label class="pl-2 Font">
                            User Name
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('USERNAME')"></i>
                        </label>
                        <input id="userName"
                               pInputText
                               type="text"
                               formControlName="userName"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>

                <div class="col-6 md:col-6" formGroupName="smtpSettings">
                    <span>
                        <label class="pl-2 Font">
                            Password
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('PASSWORD')"></i>
                            &nbsp;<i (click)="togglePasswordVisibility_Email()" [class]="isPasswordVisible_Email ? 'pi pi-eye-slash' : 'pi pi-eye'" style="cursor: pointer;" title="Click to view masked text"></i>
                        </label>
                        <input id="Password"
                               pInputText
                               [type]="isPasswordVisible_Email ? 'text' : 'password'"
                               formControlName="password"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>



                <div class="col-6 md:col-3" formGroupName="smtpSettings">
                    <span>
                        <label class="pl-2 Font">
                            From Display Name
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('DISPLAYNAME')"></i>
                        </label>
                        <input id="fromDisplayName"
                               pInputText
                               type="text"
                               formControlName="fromDisplayName"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Send To
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('SENDTO')"></i>
                        </label>
                        <input id="SendTo"
                               pInputText
                               type="text"
                               formControlName="emailNotificationsTo"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>
                <div class="col-8 md:col-4 lg:col-4 xl:col-4">
                    <span>
                        <label class="pl-2 Font">
                            Test message
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('EMAILTO')"></i>
                        </label>

                        <input id="emailNotificationsTo"
                               pInputText
                               type="text"
                               [formControl]="testEmailMessage"
                               [disabled]="isDisabled_EmailNotifications" />
                    </span>
                </div>

                <div class="col-2 md:col-1 pt-5 mb-0">
                    <button type="button" class="GreyButton p-button-plain buttonWidth-8" label="Test Email" icon="pi pi-send" pButton (click)="testSmtp()" [disabled]="!isDisabled_EmailNotifications"></button>
                </div>


            </div>
        </div>

        <div id="customlogoFeatures">
            <h5 class="col-5 md:col-1 blueBar mt-5 mb-2 ml-2 mr-3 r-2">
                Connection String Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid">
                <div class="col-6 md:col-3 ml-2">
                    <span>
                        <button type="button" style="width:56%!important" class="GreyButton p-button-plain " label="View Connection Strings" icon="pi pi-eye" pButton (click)="viewConnectionStrings()"></button>
                        <i class="pi pi-exclamation-circle pt-1" pTooltip="View the connection string details currently used by the CareFinity to connect to EHR and CareFinity databases." tooltipPosition="right"></i>
                    </span>
                </div>
                <div class="col-6 md:col-3">
                    <button type="button" style="width:58%!important" class="GreyButton p-button-plain" label="Decrypt Connection Strings" icon="pi pi-shield" pButton (click)="decryptConnectionStringModel()"></button>
                    <i class="pi pi-exclamation-circle pt-1" pTooltip="Paste a connection string from any user  to decrypt and view its details" tooltipPosition="right"></i>
                </div>
            </div>
        </div>

        <div id="customlogoFeatures">
            <h5 class="col-5 md:col-1 blueBar mt-5 mb-2 ml-2 mr-3 r-2">
                Custom Settings
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
            <div class="col-12 grid">
                <div class="col-6 md:col-3">
                    <span>
                        <input id="ShowCustomlogo" type="checkbox" formControlName="isCustomLogo" binary="true" />
                        <label class="pl-2 Font">
                            Custom Logo
                            <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('CUSTOMLOGO')"></i>
                        </label>
                    </span>
                </div>

                <div class="col-6 md:col-3">
                    <span>
                        <label class="pl-2 Font">
                            Logo Name
                            <i class="pi pi-exclamation-circle pt-1"
                               pTooltip="{{ speakText }}"
                               tooltipPosition="right"
                               (mouseover)="getContolTip('CUSTOMLOGONAME')"></i>
                        </label>
                        <input id="customlogoname"
                               type="text"
                               pInputText
                               formControlName="customLogoName" [readonly]="isDisabled_CustomName" />

                    </span>

                    <span style="color:orangered" *ngIf="frmApplicationSettings.get('customLogoName')?.errors?.invalidFileExtension">
                        Only .png or .jpg files are allowed.
                    </span>
                </div>
            </div>
        </div>

        <div>
            <h5 class="col-5 md:col-1 blueBar mt-5 mb-2 ml-2 mr-3 r-2">
                Configure Reports
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />

            <div id="reportSettings" formGroupName="reportSettings" *ngIf="isDisabled_ReportSettings">
                <div formArrayName="reportingSetting">
                    <div *ngFor="let reportGroup of reportsettingFormArray.controls; let i = index" [formGroupName]="i" class="report-group">
                        <h5 class="col-5 md:col-1 topbar" style="padding-left:12px !important;">
                            Report Settings {{ i + 1 }}
                        </h5>
                        <div class="col-12 grid">
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="reportPath-{{ i }}" class="pl-2 Font">
                                        Report Path
                                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('REPORTPATH')"></i>
                                    </label>
                                    <input id="reportPath-{{ i }}" type="text" pInputText formControlName="path" [disabled]="isDisabled_ReportSettings" />
                                </span>
                            </div>
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="dsnName-{{ i }}" class="pl-2 Font">
                                        DSN Name
                                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('DSNNAME')"></i>
                                    </label>
                                    <input id="dsnName-{{ i }}" type="text" pInputText formControlName="dsn" [disabled]="isDisabled_ReportSettings" />
                                </span>
                            </div>
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="databaseName-{{ i }}" class="pl-2 Font">
                                        Database Name
                                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('DBNAME')"></i>
                                    </label>
                                    <input id="databaseName-{{ i }}" type="text" pInputText formControlName="database" [disabled]="isDisabled_ReportSettings" />
                                </span>
                            </div>
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="dsnUserName-{{ i }}" class="pl-2 Font">
                                        DSN User Name
                                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('DSNUSERNAME')"></i>
                                    </label>
                                    <input id="dsnUserName-{{ i }}" type="text" pInputText formControlName="userName" [disabled]="isDisabled_ReportSettings" />
                                </span>
                            </div>
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="dsnPassword-{{ i }}" class="pl-2 Font">
                                        DSN Password
                                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="top" (mouseover)="getContolTip('DSNPASSWORD')"></i>
                                        &nbsp;<i (click)="togglePasswordVisibility_DSN(i)" [class]="isPasswordVisible_DSN[i] ? 'pi pi-eye-slash' : 'pi pi-eye'" style="cursor: pointer;" title="Click to view masked text">
                                        </i>
                                    </label>
                                    <input pPassword id="dsnPassword-{{ i }}" [type]="isPasswordVisible_DSN[i] ? 'text' : 'password'" pInputText formControlName="password" [disabled]="isDisabled_ReportSettings" />
                                </span>
                            </div>
                        </div>

                        <div class="col-12 grid">
                            <div class="col-4 md:col-1" style="width: max-content; text-align:left;">
                                <button pButton type="button" icon="pi pi-times" label="Remove" class="p-button-plain" (click)="removereportsettingSettings(i)"></button>
                            </div>
                            <div class="col-2 md:col-2" *ngIf="isTestdns">
                                <button type="button" class="GreyButton p-button-plain  buttonWidth-8" label="Test DNS" icon="pi pi-send" pButton (click)="testdns(i)"></button>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 md:col-1" style="width: max-content">
                        <button type="button" class="GreyButton p-button-plain" label="Add Report Setting" icon="pi pi-plus" pButton (click)="addreportsettingSettings()"></button>
                    </div>
                </div>
            </div>

        </div>

        <div>
            <h5 class="col-5 md:col-1 blueBar mt-5 mb-2 ml-2 mr-3 r-2">
                Configure SSO
            </h5>
            <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />

            <div formGroupName="ssoSettings">
                <!-- SAML Form Array -->
                <div formArrayName="saml">
                    <div *ngFor="let samlGroup of samlFormArray.controls; let i = index" [formGroupName]="i" class="saml-group">
                        <h5 class="col-5 md:col-1 topbar" style="padding-left:12px !important;">
                            SAML Setting {{ i + 1 }}
                        </h5>

                        <div class="grid col-12">
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="certificatePath-{{ i }}" class="pl-2 Font">
                                        Certificate Path
                                        <i class="pi pi-exclamation-circle pt-1"
                                           pTooltip="{{ speakText }}"
                                           tooltipPosition="right"
                                           (mouseover)="getContolTip('CERTIFICATEPATH')"></i>
                                    </label>
                                    <input id="certificatePath-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="certificatePath" />
                                </span>
                            </div>

                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="senderEntityID-{{ i }}" class="pl-2 Font">
                                        Sender Entity ID<i class="pi pi-exclamation-circle pt-1"
                                                           pTooltip="{{ speakText }}"
                                                           tooltipPosition="right"
                                                           (mouseover)="getContolTip('ENTITYID')"></i>
                                    </label>
                                    <input id="senderEntityID-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="senderEntityID" />
                                </span>
                            </div>

                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="firstNameAttribute-{{ i }}" class="pl-2 Font">
                                        First Name Attribute<i class="pi pi-exclamation-circle pt-1"
                                                               pTooltip="{{ speakText }}"
                                                               tooltipPosition="right"
                                                               (mouseover)="getContolTip('ATTRIBUTENAME')"></i>
                                    </label>
                                    <input id="firstNameAttribute-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="firstNameAttribute" />
                                </span>
                            </div>
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="lastNameAttribute-{{ i }}" class="pl-2 Font">
                                        Last Name Attribute<i class="pi pi-exclamation-circle pt-1"
                                                              pTooltip="{{ speakText }}"
                                                              tooltipPosition="right"
                                                              (mouseover)="getContolTip('LASTATTRIBUTENAME')"></i>
                                    </label>
                                    <input id="lastNameAttribute-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="lastNameAttribute" />
                                </span>
                            </div>
                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="dobAttribute-{{ i }}" class="pl-2 Font">
                                        DOB Attribute
                                        <i class="pi pi-exclamation-circle pt-1"
                                           pTooltip="{{ speakText }}"
                                           tooltipPosition="right"
                                           (mouseover)="getContolTip('DOB')"></i>
                                    </label>
                                    <input id="dobAttribute-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="dobAttribute" />
                                </span>
                            </div>

                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="mrnAttribute-{{ i }}" class="pl-2 Font">
                                        MRN Attribute<i class="pi pi-exclamation-circle pt-1"
                                                        pTooltip="{{ speakText }}"
                                                        tooltipPosition="right"
                                                        (mouseover)="getContolTip('MRN')"></i>
                                    </label>
                                    <input id="mrnAttribute-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="mrnAttribute" />
                                </span>
                            </div>

                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="ehrPracticeIdAttribute-{{ i }}" class="pl-2 Font">
                                        EHR Practice ID Attribute<i class="pi pi-exclamation-circle pt-1"
                                                                    pTooltip="{{ speakText }}"
                                                                    tooltipPosition="right"
                                                                    (mouseover)="getContolTip('EHR')"></i>
                                    </label>
                                    <input id="ehrPracticeIdAttribute-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="ehrPracticeIdAttribute" />
                                </span>
                            </div>
                        </div>

                        <div class="grid col-12">
                            <div class="col-6 md:col-3 Pad">
                                <span>
                                    <input id="traceRequests-{{ i }}"
                                           formControlName="traceRequests"
                                           type="checkbox"
                                           binary="true" />
                                    <label for="traceRequests-{{ i }}" class="pl-2 Font">
                                        Enable Trace<i class="pi pi-exclamation-circle pt-1"
                                                       pTooltip="{{ speakText }}"
                                                       tooltipPosition="right"
                                                       (mouseover)="getContolTip('TRACE')"></i>
                                    </label>
                                </span>
                            </div>

                            <div class="col-6 md:col-3">
                                <span>
                                    <label for="tracePath-{{ i }}" class="pl-2 Font">
                                        Trace Path<i class="pi pi-exclamation-circle pt-1"
                                                     pTooltip="{{ speakText }}"
                                                     tooltipPosition="right"
                                                     (mouseover)="getContolTip('TRACEPATH')"></i>
                                    </label>
                                    <input id="tracePath-{{ i }}"
                                           pInputText
                                           type="text"
                                           formControlName="tracePath" />
                                </span>
                            </div>

                            <div class="col-6 md:col-3 Pad">
                                <span>
                                    <input id="collapsedMenuBar-{{ i }}" formControlName="collapsedMenuBar" type="checkbox" binary="true" />
                                    <label for="collapsedMenuBar-{{ i }}" class="pl-2 Font">
                                        Collapse Menu Bar
                                        <i class="pi pi-exclamation-circle pt-1" pTooltip="{{ speakText }}" tooltipPosition="right" (mouseover)="getContolTip('CMB')"></i>
                                    </label>
                                </span>
                            </div>
                        </div>
                        <div class="col-1 md:col-1">
                            <button pButton type="button" icon="pi pi-times" label="Remove   " class="p-button-plain" (click)="removeSamlSettings(i)"></button>
                        </div>
                    </div>
                    <div class="col-4 md:col-1" style="width: max-content">
                        <button type="button" class="GreyButton p-button-plain" label="Add SAML Setting" icon="pi pi-plus" pButton (click)="addSamlSettings()"></button>
                    </div>
                </div>
            </div>
        </div>

        <hr style="border-width: 2px 0 0 0; border-color: #9fa5b3;" />
        <div class="grid col-12">
            <div class="col-4 md:col-1" style="width: max-content">
                <span>
                    <button pButton icon="pi pi-save" label="Save Global Configuration" type="submit" [disabled]="isSaving"></button>&nbsp;

                </span>
            </div>
        </div>
    </form>

</div>
<p-dialog [(visible)]="isConnectionStringVisiable"
          [draggable]="true"
          [modal]="true"
          positionType="absolute"
          [style]="{ width: '50vw' }"
          [baseZIndex]="10000"
          [maximizable]="true">
    <p-header>
        <h3> Connection Strings </h3>
    </p-header>

    <div class="card pb-0">
        <app-decryptconnection-strings></app-decryptconnection-strings>

    </div>


</p-dialog>
<p-dialog header="Application Setting Message"
          [(visible)]="showglobalSettingMessage"
          [draggable]="false"
          [modal]="true"
          positionType="absolute"
          [closable]="false"
          [maximizable]="false"
          [style]="{ width: '20vw' }">
    <div [innerHtml]="globalMessage"></div>

    <div class="flex flex-row-reverse">
        <p-button label="OK"
                  (click)="resetglobalMessage()"></p-button>
    </div>
</p-dialog>
<p-dialog [(visible)]="isConnectionStringDecryptVisiable"
          [draggable]="true"
          [modal]="true"
          positionType="absolute"
          [style]="{ width: '60vw' }"
          [baseZIndex]="10000"
          [maximizable]="true">
    <p-header>
        <h3>
            <i class="pi pi-shield"></i>&nbsp;Decrypt Connection Strings
        </h3>
    </p-header>

    <form [formGroup]="connectionForm" (ngSubmit)="decryptConnections()">
        <div class="col-12">
            <label for="careFinityConnectionString" class="form-label Font">
                <b> CareFinity Connection String</b>
            </label>

        </div>
        <div class="col-12">

            <textarea [rows]="5"
                      [cols]="150"
                      pInputTextarea
                      formControlName="careFinityConstring"></textarea>

        </div>
        <div class="col-12">
            <label for="eHREMRConnectionString" class="form-label Font">
                <b>EHR_EMR Connection String</b>
            </label>

        </div>
        <div class="col-12">

            <textarea [rows]="5"
                      [cols]="150"
                      pInputTextarea
                      formControlName="ehremrConstring"></textarea>

        </div>


        <div class="col-6 md:col-6" style="width: max-content;">
            <span>
                <button type="submit" class=" p-button-plain ml-3" label="Decrypt Connection strings" icon="pi pi-reply" pButton [disabled]="!isFormFilled()"></button>
            </span>


        </div>

    </form>


    <div *ngIf="isDecConVisiable">
        <div class="col-12">
            <label for="careFinityConnectionString" class="form-label Font">
                <b>CareFinity Connection String</b>
            </label>

        </div>



        <div class="col-12">
            <textarea [rows]="3"
                      [cols]="150"
                      pInputTextarea
                      autoResize="autoResize"
                      [value]="decitems.careFinityConstring" [ngClass]="{ 'copiedCareFinity': isCopiedCareFinity}"></textarea>

            <span>
                <i class="pi pi-copy pt-1" pTooltip="Copy text" style="color:#1e35a4" (click)="copyTextCareFinityConstring()"></i>
            </span>
        </div>
        <div class="col-12">
            <label for="eHREMRConnectionString" class="form-label Font">
                <b>EHR_EMR Connection String</b>
            </label>

        </div>


        <div class="col-12">
            <textarea [rows]="3"
                      [cols]="150"
                      pInputTextarea
                      autoResize="autoResize"
                      [value]="decitems.ehremrConstring" [ngClass]="{ 'copiedEhremrConstring': isCopiedEhremrConstring }"></textarea>
            <span>
                <i class="pi pi-copy pt-1" pTooltip="Copy text" style="color:#1e35a4" (click)="copyTextEhremrConstring()"></i>
            </span>
        </div>


        <div class="col-6 md:col-6" style="width: max-content;">

            <button pButton icon="pi pi-undo" label="Reset" (click)="resetDecryptConStrings();"></button>&nbsp;
            <button pButton icon="pi pi-times" label="Cancel" (click)="CloseDecryptConStrings();"></button>&nbsp;

        </div>
    </div>

</p-dialog>
